
const digest = '95a91a9d31d488f732597586fa38c5010f63badcb850115cf79b7d8e5f46bd50';
const classes = {"wrapper":"_wrapper_5qr1d_1","checkbox":"_checkbox_5qr1d_9","active":"_active_5qr1d_19","title":"_title_5qr1d_24","childrenWrapper":"_childrenWrapper_5qr1d_32","disabled":"_disabled_5qr1d_36"};
const css = `._wrapper_5qr1d_1 {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  height: fit-content;
  font-family: Poppins, sans-serif;
}

._checkbox_5qr1d_9 {
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
  background: url("/dist/patientV3/icons/checkbox-default.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}

._active_5qr1d_19 {
  background: url("/dist/patientV3/icons/checkbox-checked.svg") no-repeat center;
  background-size: contain;
}

._title_5qr1d_24 {
  font-size: 14px;
  font-weight: 600;
  margin-left: 7.5px;
  color: #3c3f9c;
  padding-top: 5px;
}

._childrenWrapper_5qr1d_32 {
  margin-left: 7.5px;
}

._disabled_5qr1d_36 {
  cursor: not-allowed;
}
._disabled_5qr1d_36 ._checkbox_5qr1d_9 {
  opacity: 0.8;
  cursor: not-allowed;
}
._disabled_5qr1d_36 ._title_5qr1d_24 {
  color: #939393;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  